import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { flowRight as compose } from 'lodash';

import DspPreAuthorizedEventList from './DspPreAuthorizedEventList';
import DspTransactionList from './DspTransactionList';
import DspTransactionInfo from './DspTransactionInfo';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';

const styles = {
  container: {
    padding: '16px',
  },
  rootBox: {
    padding: '16px',
    backgroundColor: '#fff',
    width: '100%',
  },
  root: {
    flexGrow: 1,
  },
  tab: {
    '& .MuiTab-root': {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#5a5a5a',
      textTransform: 'capitalize',
    },
    '& .MuiTabs-indicator': {
      height: '4px',
      backgroundColor: '#6c62f5',
    },
  },
};

const Payments = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { store, contractorStore } = props;
  const dspId = store.userStore.accountData?.id;

  const [value, setValue] = React.useState('events');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    if (dspId) contractorStore.getDspDetails(dspId);
  }, [dspId]);

  useEffect(() => {
    if (location.pathname.includes('transactions')) {
      setValue('transactions');
    } else setValue('events');
  }, [location.pathname]);

  return (
    <Box sx={styles.root}>
      <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" centered>
        <Tab label="Pre-Authorized" value="events" onClick={() => navigate('/payments/events')}  sx={{ fontSize: 13 }} />
        <Tab label="Transaction History" value="transactions" onClick={() => navigate('/payments/transactions')} sx={{ fontSize: 13 }} />
      </Tabs>
      <Grid container justifyContent="center" sx={styles.container}>
        <Box sx={styles.rootBox}>
          <Routes>
            <Route path="transactions" element={<DspTransactionList />} />
            <Route path="transactions/:paymentId" element={<DspTransactionInfo />} />
            <Route path="*" element={<DspPreAuthorizedEventList />} />
          </Routes>
        </Box>
      </Grid>
    </Box>
  );
};

export default compose(inject('contractorStore', 'dspEventStore', 'searchDspPaymentStore', 'paymentStore', 'store'), observer)(Payments);
